import { useCallback, useEffect, useState } from 'react';
import { useAxios } from '../../Helpers/AxiosHelper';
import { Dropdown, DropdownChangeEvent, ProgressSpinner } from '../../Common/Imports';
import { ApiResponse, DDModel, Status_EXT } from '../../Models/Classes';


interface DDStatusProps {
    IDType: number | undefined;
    onChange?: (IdBrand: number | undefined) => void;
    value?: number;
    onBlur?: () => void;
    showClear?: boolean;
}

export const DDStatus: React.FC<DDStatusProps> = ({ value, onChange, IDType, showClear = false }) => {
    const [data, setData] = useState<DDModel<Status_EXT>[] | undefined>();
    const [selectedElem, setSelectedElem] = useState<DDModel<Status_EXT> | undefined>();
    const AxiosHelper = useAxios();

    const GetData = useCallback(async () => {
        try {
            const resp = await AxiosHelper.get<ApiResponse<DDModel<Status_EXT>[]>>(`DropDown/Status?IDType=${IDType}`);
            if (resp.data.code === 0) {
                setData(resp.data.data);
            }
        } catch (error) {
            console.error('Error fetching countries:', error);
        }
    }, [AxiosHelper, IDType]);

    useEffect(() => {
        GetData();
    }, [GetData]);


    useEffect(() => {
        if (data)
            setSelectedElem(data.find(m => m.id === value));
    }, [data, value]);

    const handleChange = (e: DropdownChangeEvent) => {
        const _val = e.value as DDModel<Status_EXT> | undefined;
        setSelectedElem(_val);
        if (onChange && _val) {
            const id = _val.id as number
            onChange(id);
        } else if (onChange) {
            onChange(undefined);
        }
    };

    return (

        data ?
            <Dropdown
                value={selectedElem}
                onChange={handleChange}
                options={data}
                optionLabel="label"
                showClear={showClear}
                className="w-100" />
            :
            <ProgressSpinner style={{ width: '35px', height: '35px' }} />

    );
};
